import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
const urlAuthPath = "https://wht.revotax.com/api/v1/admin"
// const urlUploadPath = "http://wht.revotax.com/uploads";
const urlUploadPath = "http://localhost:4004/withholding";

export default new Vuex.Store({
  state: {
    adminDetails: null,
    token: null,
    test: 0,
    allStates: [],
    adminMenus: [],
    allItems: [],
    statesEnrolled: [],
    refreshAgentsList: false
  },
  getters: {
    adminName: (state) => {
      if (state.adminDetails.isGivenName && state.adminDetails.familyName) {
        return `${state.adminDetails.isGivenName} ${state.adminDetails.familyName}`
      }else if (!state.adminDetails.isGivenName && state.adminDetails.familyName) {
        return `Admin ${state.adminDetails.familyName}`
      }else if (state.adminDetails.isGivenName && !state.adminDetails.familyName) {
        return `Admin ${state.adminDetails.isGivenName}`
      }else{
        return `${state.adminDetails.isGivenName} ${state.adminDetails.familyName}`
      }
    },
    stateName: (state) => (code) => {
      return state.allStates.find(stt => stt.stateCode == code).stateName
    },
    everyStates: (state) => {
      return state.allStates
    },
    everyItems: (state) => {
      return state.allItems
    }
  },
  mutations: {
    SET_ADMIN_DETAILS(state, details){
      state.adminDetails = details
    },
    SET_ADMIN_MENUS(state, details){
      state.adminMenus = details
    },
    SET_TOKEN(state, token){
      state.token = token
    },
    SET_ALLSTATES(state, values){
      state.allStates = values
    },
    SET_ALLITEMS(state, values){
      state.allItems = values
    },
    SET_STATESENROLLED(state, values){
      state.statesEnrolled = values
    },
    SET_REFRESH_AGENT_LIST(state, value){
      state.refreshAgentsList = value
    }
  },
  actions: {
    addAdminDetails(context, adminDetails){
      // add to localstorage
      const data = JSON.stringify(adminDetails);
      const encodedString = btoa(data);
      localStorage.setItem('GWEND127', encodedString)

      // add to store
      context.commit('SET_ADMIN_DETAILS', adminDetails)
    },
    
    addAdminMenu(context, adminMenus){
      // add to localstorage
      const data = JSON.stringify(adminMenus);
      console.log(data);
      const encodedString = btoa(data);
      localStorage.setItem('GWENDMENU', encodedString)

      // add to store
      context.commit('SET_ADMIN_MENUS', adminMenus)
    },

    updateAdminMenu({state, commit}){
      // Get adminDetails from localstorage and add to store, if adminDetails is empty (for page refresh)
      if (!state.adminMenus.length) {
        const encodedString = localStorage.getItem('GWENDMENU')
        const decodedString = atob(encodedString);
        const adminMenus = JSON.parse(decodedString);
        commit('SET_ADMIN_MENUS', adminMenus)
      }
    },

    updateAdminDetails({state, commit}){
      // Get adminDetails from localstorage and add to store, if adminDetails is empty (for page refresh)
      if (!state.adminDetails) {
        const encodedString = localStorage.getItem('GWEND127')
        const decodedString = atob(encodedString);
        const adminDetails = JSON.parse(decodedString);

        commit('SET_ADMIN_DETAILS', adminDetails)
      }
    },

    addToken(context, token){
      // add to localstorage
      localStorage.setItem('XATHWAT', token)

      // add to store
      context.commit('SET_TOKEN', token)
    },

    updateToken({state, commit}){
      // Get token from localstorage and add to store, if token is empty (for page refresh)
      if (!state.token) {
        const token = localStorage.getItem('XATHWAT')

        commit('SET_TOKEN', token)
      }
    },

    addAllStates({state, commit}){
      if (!state.allStates.length) {
        const stateUrl = `${urlAuthPath}/states`;
        axios.get(stateUrl,{
          headers:{
            "x-access-token": state.token
          }
        })
        .then(result => {
          if (result.data.data.code == "S200") {
            // add to store
            commit('SET_ALLSTATES', result.data.data.message)
          }else{
            console.log(result.data.data.message)
          }
        })
        .catch(err => console.log(err))
      }
    },

    addAllItems({state, commit}){
      if (!state.allItems.length) {
        const itemUrl = `${urlUploadPath}/item`;
        axios.get(itemUrl,{
          headers:{
            "x-access-token": state.token
          }
        })
        .then(result => {
          if (result.data.data.code == "S200") {
            // add to store
            commit('SET_ALLITEMS', result.data.data.message);
          }else{
            console.log(result.data.data.message)
          }
        })
        .catch(err => console.log(err))
      }
    },

    addStatesEnrolled(context, statesEnrolled){
      // add to store
      context.commit('SET_STATESENROLLED', statesEnrolled)
    },

    update_refreshAgentsList(context, val){
      context.commit('SET_REFRESH_AGENT_LIST', val)
    }
  },
  modules: {

  }
})
